// 管道总览
import { useNavigate, useLocation } from 'react-router-dom'
import React, { useState, useRef, useEffect } from 'react'
import { Card, theme, Input, Button, Drawer, Modal, Space, Form, Spin, message, Popconfirm, Tooltip, Divider, Tree, Dropdown, List } from 'antd'
import Icon, { DeleteOutlined, QuestionCircleOutlined, NodeIndexOutlined, ExclamationCircleOutlined, SettingOutlined, FontColorsOutlined, MenuOutlined, EyeOutlined, EyeInvisibleOutlined, FormOutlined, FlagOutlined, ThunderboltOutlined, NodeCollapseOutlined, RotateLeftOutlined, BlockOutlined } from '@ant-design/icons'
import { transformGCJ2WGS, transformWGSGCJ2, distance, demoMap, getTreeDataByDelayeringData, debounce } from "@/common/js/common.js" //引入公共方法
import dayjs from 'dayjs';
import AntIcon from '@/component/antIcon/index.js'

import { getAirportListApi, } from '@/server/new_pipeline_inspection.js'
import { setOverviewListApi, uploadKMLApi, getOverviewTreeDataApi, submitOverviewDataApi, delOverviewListApi, setStationInfoApi, getStationListApi, delStationListApi, getStationInfoApi, getMapCenterPointApi, setMapCenterPointApi } from '@/server/pipeline_overview.js'

import {
  Amap as RMap,
  Scale,
  Marker,
  Circle,
  Polyline,
  MassMarks,
  TileLayer,
  BezierCurve,
  config as AmapReactConfig,
  Marker as AmapMarker,
  LabelsLayer as AmapLabelsLayer,
  LabelMarker as AmapLabelMarker,
} from '@amap/amap-react';


import './index.css'
import { getWebSocketAddress } from '@/server/commandFlight.js'
import map_jc from "@/common/img/command_flight/map_jc.svg" //机场
import map_uavJT from "@/common/img/command_flight/map_uavJT.svg" //无人机箭头
import bsz_map from '@/common/img/pipeline_overview/bsz.svg'//标识桩  地图展示
import cz_cs from '@/common/img/pipeline_overview/cz_cs.svg'//场站测试
import jc_cdz from '@/common/img/pipeline_overview/jc_cdz.svg'//机场_充电中
import jc_kxz from '@/common/img/pipeline_overview/jc_kxz.svg'//机场_空闲中
import jc_lxz from '@/common/img/pipeline_overview/jc_lxz.svg'//机场_离线中
import jc_tsz from '@/common/img/pipeline_overview/jc_tsz.svg'//机场_调试中
import jc_rwz from '@/common/img/pipeline_overview/jc_rwz.svg'//机场_任务中

//0:机场;  1:气管; 3:标识桩; 7:电网; 11:水管;  12:油管;  13:光缆;  14:场站; 15:地图定位
function PipelineOverview () {
  const navigate = useNavigate();//路由跳转
  const location = useLocation();//路由接受参数
  const token = localStorage.getItem('dock_token')
  const mapkeys = [
    '86d93748cf75968bb768bfb9ff4b19fc',
    '86d93748cf75968bb768bfb9ff4b19fc',
    '86d93748cf75968bb768bfb9ff4b19fc'
  ];//天地图key
  const [choose_map_key, setChooseMapKey] = useState(0);//随机 0，1，2从 mapkeys 中取一个地图key
  const mapRef = useRef()//地图
  const ws = useRef()//WebSocket
  const [stationForm] = Form.useForm()//场站表单

  const { token: { colorBgContainer, colorText } } = theme.useToken(); //获取主题颜色

  const [messageApi, contextHolder] = message.useMessage()

  const [divLeft, setDivLeft] = useState(0);//
  const [divTop, setDivTop] = useState(0);
  const [floating, setFloating] = useState({
    visible: false,//是否可见
    title: '',//航线名称
  });

  const circleMoveRef = useRef(false);

  const [isInitialize, setIsInitialize] = useState(false);//是否初始化
  const [zoom, setZoom] = useState(17); //地图缩放比例
  const scale = 3875.8509003722434;//初始化地图比例尺
  const [mapScale, setmapScale] = useState(3875.8509003722434) // 地图当前比例尺
  const [opacity, setOpacity] = useState(true);//切换图层
  const [center_point, setCenterPoint] = useState([104.186394, 30.837415]);//地图中心点
  const centerPointref = useRef([104.186394, 30.837415]);



  const limitsAuthority = useRef([]);//权限
  const [loading, setLoading] = useState(false)//加载中···
  const [selectModal, setSelectModal] = useState({//上传  对话框列表
    isOpen: false,
    upLoadType: 0,//需要上传的类型  0:机场;  1:气管;  3:标识桩;  7:电网;  11:水管;  12:油管;  13:光缆;  14:场站;
    upLoadCoordinateSystem: undefined,//需要上传的坐标系
    loading: false,
  });
  const [stationDrawer, setStationDrawer] = useState({//场站、设置中心点  抽屉
    title: '',
    st_id: null,
    isOpen: false,
    loading: false,
    upLoadType: 0,//需要上传的类型  14:场站； 15:地图定位
    upLoadCoordinateSystem: undefined,//需要上传的坐标系
  })

  const visableArrRef = useRef([0, 1, 3, 7, 11, 12, 13, 14])//需要显示的管道项目
  const [visableArr, setVisableArr] = useState([0, 1, 3, 7, 11, 12, 13, 14])//需要显示的管道项目

  const [treeList, setTreeList] = useState({//tree组件所需
    data: [],//原始数据
    arrData: [],//树所需信息
    isRightClick: false,//是否右击
    list: {},//右击的列表项
    clickType: 0,
    rightClickId: undefined,//右击的id
    rightClickPageX: undefined,//右键点击  位置
    rightClickPageY: undefined,//右键点击  位置
    openDel: false,//是否打开删除
    openNewName: false,//是否打开重命名对话框
    oldName: '',//旧名称
    newName: '',//新名称    
    openVisableDropdown: false,//打开全局的显示隐藏管线
  })

  const [curSize, setCurSize] = useState(11)//当前地图的缩放级别
  const [curMouseMove, setCurMouseMove] = useState([0, 0])//当前鼠标移动的坐标点
  const [altitudeList, setAltitudeList] = useState({//海拔集合
    bigmap: 0,//bigemap的海拔
    V3: 0,//谷歌v3版 海拔
  })

  const dockListRef = useRef([])//显示机场数据
  const [dockList, setDockList] = useState([])//机场列表集合
  const [showPipelines, setShowPipelines] = useState([])//需要展示的  管线、标识桩、场站

  const [visableList, setVisableList] = useState({//当前显示隐藏项
    oldIds: [],//上一次点击的项目ids
    newIds: [],//当前点击的项目ids
  })

  const getDataList = async () => {//获取所有管线 数据
    setLoading(true)
    let res = await getOverviewTreeDataApi({ access_token: token })
    if (res.ret !== 200) {
      messageApi.open({
        type: 'warning',
        content: `${res.msg || '数据跑丢了!'}`,
      });
      setLoading(false)
      return;
    }
    if (res.data && res.data.length > 0) { res.data.map(ele => { return { ...ele, key: ele.id } }) }
    let tre = treeList
    tre.data = deepCopy(res.data)
    setTreeList({ ...tre })
    setLoading(false)
    getallStation()
  }

  const getallStation = async () => { //获取 所有 场站  数据
    let tre = treeList
    let res = await getStationListApi({ access_token: token })
    if (res.ret !== 200) { message.warning(res.msg || '数据跑丢了！') }

    (res?.data?.list || []).forEach((ele, index) => {
      let obj = {
        ...ele,
        pid: 0,
        realId: ele.id,
        id: dayjs().valueOf() + ele.id,
        pipe_name: ele.station_name,
        pipe_type: 14,
        type: 14
      }
      tre.data.push(obj)
    })

    setTreeList({ ...tre })
    editDataArr(tre.data)
    getAllAirportList()
  }

  const getAllAirportList = async () => {  // 获取所有机场 数据
    let res = await getAirportListApi({ access_token: token })
    if (res.ret !== 200) { message.warning(res.msg || '数据跑丢了！'); return }
    if (res.data.length) {

      let arr = res.data.map(e => {
        return {
          ...e,
          dock_type: 0,//机场状态   ws包含：{0:空闲中，1：现场调试，2：远程调试，3：固件升级中，4：作业中}   新增：{5：断开链接}
          dock_chargeState: 0,//飞行器 充电状态  {0：空闲，1：充电中}
          dock_electricQuantity: 0,//电量
          aircraft_latLng: [],//无人机 经纬度
          aircraft_angle: 0,//无人机 角度
          dock_time: dayjs().valueOf(),//机场获取到数据的时间
          aircraft_time: dayjs().valueOf(),//无人机获取到数据的时间
        }
      })
      dockListRef.current = arr
      setDockList([...arr])
      getDockStateByWs(arr)
    }
  }

  const newDockInfoDataRef = useRef([])//ws获取的最新数据
  const oldDockInfoDataRef = useRef([])//上一版数据
  const changeInfoIndexRef = useRef([])//当前改变的机场数据下标
  const getDockStateByWs = async (dockListArr) => {//获取ws信息并写入dataList中
    let obj = {}
    let num = 1
    let res = await getWebSocketAddress({ access_token: token, type: 1 })
    if (res.ret !== 200) { message.warning(res.msg || '数据跑丢了！'); return }

    if (res.ret === 200) {
      ws.current = new WebSocket(res.data);

      ws.current.onopen = (msg) => {//链接开启
        console.log("链接成功", msg);
      };

      ws.current.onmessage = e => {// 成功获取数据
        let data = JSON.parse(e.data)

        // console.log('ws的数据', data.data)

        objectsBecomeList(data.data.host, obj)

        dockListArr.forEach((res, index) => {
          newDockInfoDataRef.current[index] = { ...res, ...newDockInfoDataRef.current[index] }
          if (data.biz_code === 'dock_osd' && res.dockSn === data.data.sn) {//机场信息

            if (data?.data?.host?.mode_code || data?.data?.host?.mode_code === 0) { newDockInfoDataRef.current[index].dock_type = data?.data?.host?.mode_code }
            if (data?.data?.host?.drone_charge_state?.state || data?.data?.host?.drone_charge_state?.state === 0) { newDockInfoDataRef.current[index].dock_chargeState = data?.data?.host?.drone_charge_state?.state }
            if (data?.data?.host?.drone_charge_state?.capacity_percent || data?.data?.host?.drone_charge_state?.capacity_percent === 0) { newDockInfoDataRef.current[index].dock_electricQuantity = data?.data?.host?.drone_charge_state?.capacity_percent }
            newDockInfoDataRef.current[index].dock_time = dayjs().valueOf()
          }

          if (data.biz_code === 'device_osd' && res.aircraftSn === data.data.sn) {//无人机信息
            newDockInfoDataRef.current[index].aircraft_angle = data?.data?.host?.attitude_head
            newDockInfoDataRef.current[index].aircraft_latLng = data?.data?.host?.latitude ? [data?.data?.host?.latitude, data?.data?.host?.longitude] : [0, 0]
            newDockInfoDataRef.current[index].aircraft_time = dayjs().valueOf()
          }
        })

        if (num === 1) {
          setTimeout(() => {
            dockListRef.current = newDockInfoDataRef.current
            setDockList([...dockList, ...dockListRef.current])//暂时上的版本
          }, 1000);

          num += 1
        }
      }

      ws.current.onerror = (msg) => {//报错信息
        // console.log('链接出错', msg)
        // closeWs.current = false
        message.warning('当前ws链接网络不佳，请稍后再试···')
      }
      //链接断开
      ws.current.onclose = (msg) => {
        setUAVData({})
        clearInterval(settime)
      }

      dockListRef.current = newDockInfoDataRef.current
      setDockList([...dockListArr, ...dockListRef.current])
      setInterval(() => {
        changeInfoIndexRef.current = findDifferences(oldDockInfoDataRef.current, newDockInfoDataRef.current)
        setDockList([...dockListArr, ...dockListRef.current])//暂时上的版本
      }, 5000);
    } else {
      message.warning(res.msg || '系统出错啦，请稍后重试！')
    }
  }

  const objectsBecomeList = (data = [], list, name = null) => {//将多级objcet转换成单级objcet
    Object?.keys(data).forEach(res => {
      if (typeof data[res] === 'object') {
        objectsBecomeList(data[res], list, res)
      } else {
        if (name) {
          let na = `${name}_${res}`
          list[na] = data[res]
        } else {
          list[res] = data[res]
        }
      }
    })
  }

  const submitDrawer = async (data) => { //表单提交
    let sta = stationDrawer
    if (stationDrawer.upLoadType === 14) { //场站
      let obj = {
        access_token: token,
        st_id: sta.st_id,
        station_name: data.stationName,
        lon: data.longitude,
        lat: data.latitude,
      }
      let res = await setStationInfoApi(obj)
      if (res.ret !== 200) { message.warning(res.msg || '数据跑丢了！'); return }
    }

    if (stationDrawer.upLoadType === 15) { //地图定位
      let obj = {
        access_token: token,
        lon: data.longitude,
        lat: data.latitude,
      }
      let res = await setMapCenterPointApi(obj)
      if (res.ret !== 200) { message.warning(res.msg || '数据跑丢了！'); return }
      mapRef.current.setView([obj.lat, obj.lon])
      localStorage.setItem('dock_DefaultMapPoints', JSON.stringify([Number(obj.lat), Number(obj.lon)]))
    }
    sta.isOpen = false
    sta.title = ''
    sta.upLoadType = 0
    sta.st_id = null
    setStationDrawer({ ...sta })
    getDataList()
  }

  const getGetAltitude = async (arr) => {//获取海拔接口
    try {
      const response = await fetch(`terprofile/v1/bigemap.903y00vn/${arr[0]},${arr[1]}?access_token=pk.eyJ1IjoiY3VzX2QwaHVsaXh0IiwiYSI6ImVudjk5Zjdhb2dhemI5cWx4NDZjaDd0eXMifQ.D1uMGsHLHtI66G6BHDcnww`);
      if (!response.ok) { throw new Error('Network response was not ok'); }
      const result = await response.json()
      let alt = altitudeList
      alt.V3 = result[0].height ? Number(result[0]?.height?.toFixed(1)) : 0
      setAltitudeList({ ...alt })
    } catch (error) {
      // setError(error.message);
    } finally {
      // setLoading(false);
    }
  }

  const editDataArr = (dataArr) => { //重新编辑数组数据
    let ddd = []
    let rawData = []
    let tre = treeList
    dataArr.forEach((res, index) => {
      res.isShowLine = res.isShowLine || res.isShowLine === false ? res.isShowLine : true
      res.key = res.id
      res.title = (
        <span
          onDoubleClick={() => {//双击标题  定位地图中心点
            if (res.pipe_type === 14) {
              mapRef.current.setView([res.lat, res.lon])
            } else {
              if (res.point_lines && res.point_lines.length > 0 && res.isShowLine) { mapRef.current.setView([res.point_lines[0].lat_wgs84, res.point_lines[0].lon_wgs84]) }
            }
          }}
        >
          {res.pipe_name}
        </span >
      )
      res.type = res.point_lines && res.point_lines.length > 0 ? res.pipe_type : res.type || undefined
      res.icon = (
        <span
          key={index}
          onClick={(event) => {
            event.stopPropagation()
            let vis = visableList
            vis.oldIds = []
            vis.newIds = visableDataArr(res)
            dataArr.forEach(e => { if (!e.isShowLine) { vis.oldIds.push(e.id) } })
            vis.newIds.forEach(r => {
              if (res.children && res.children.length > 0) {//选中父级
                if (res.isShowLine) {//需要选中
                  vis.oldIds.push(r)
                } else { //需要释放
                  vis.oldIds.splice(vis.oldIds.findIndex(e => e === r), 1)
                }
              } else {//子集
                if (vis.oldIds.indexOf(r) < 0) {
                  vis.oldIds.push(r)
                } else {
                  vis.oldIds.splice(vis.oldIds.findIndex(e => e === r), 1)
                }
              }
            })//将选中的不存在于oldids的数据放入
            dataArr.map(r => {
              r.isShowLine = true
              if (vis.oldIds.indexOf(r.id) > -1) {
                r.isShowLine = false
              } else {
                r.isShowLine = true
              }
              return r
            })
            setVisableList({ ...vis })
            editDataArr(dataArr)
          }}
        >
          {res.isShowLine ? <EyeOutlined /> : <EyeInvisibleOutlined className='opa45' />}
        </span>
      )

      switch (res.type) {
        case 1://气管
          res.switcherIcon = <Tooltip placement="left" title='气管'><><AntIcon type='qg' /></></Tooltip>
          break;
        case 3://标识桩
          res.switcherIcon = <Tooltip placement="left" title='标识桩'><FlagOutlined /></Tooltip>
          break;
        case 7://电网
          res.switcherIcon = <Tooltip placement="left" title='电网'><ThunderboltOutlined /></Tooltip>
          break;
        case 11://水管
          res.switcherIcon = <Tooltip placement="left" title='水管'><><AntIcon type='sg' /></></Tooltip>
          break;
        case 12://油管
          res.switcherIcon = <Tooltip placement="left" title='油管'><><AntIcon type='yg' /></></Tooltip>
          break;
        case 13://光缆
          res.switcherIcon = <Tooltip placement="left" title='光缆'><><AntIcon type='gl' /></></Tooltip>
          break;
        case 14://场站
          res.switcherIcon = <Tooltip placement="left" title='场站'><><AntIcon type='cz' /></></Tooltip>
          break;
        default:
          break;
      }
      ddd.push(res)
      if (res.point_lines && res.point_lines.length > 0) { rawData.push(res) }
    })

    tre.data = ddd
    edtiPoints(tre.data)
    tre.arrData = getTreeDataByDelayeringData(ddd, 'pid', 'key')
    setTreeList({ ...tre })
  }

  const deepCopy = (obj) => {//深拷贝
    if (obj === null || typeof obj !== 'object') {
      return obj;
    }

    if (Array.isArray(obj)) {
      let copy = [];
      for (let i = 0; i < obj.length; i++) {
        copy[i] = deepCopy(obj[i]);
      }
      return copy;
    } else {
      let copy = {};
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          copy[key] = deepCopy(obj[key]);
        }
      }
      return copy;
    }
  }

  const visableDataArr = (dataArr) => { //显示隐藏图标逻辑
    let arr = [];
    arr.push(dataArr.id);
    if (dataArr.children && dataArr.children.length > 0) {
      for (let i = 0; i < dataArr.children.length; i++) {
        arr = [...arr, ...visableDataArr(dataArr.children[i])]
      }
    }
    return arr
  }

  const edtiPoints = (dataArr) => {//编辑航线
    let mainList = []//主列表
    let arr = []//存在点位的数据

    if (dataArr && dataArr.length > 0) {
      dataArr.forEach((res => {
        if (res.pid === 0) {
          let pts = []
          mainList.push({
            mainId: res.id,
            name: res.pipe_name,
            pipe_type: res.pipe_type,
            points: pts,
          })
        }
        if ((res.point_lines && res.point_lines.length > 0) || (res.pipe_type === 14)) { arr.push(res) }
      }))

      arr.forEach(res => {
        if (!res.isShowLine) { return }
        let point
        if (res.pipe_type === 3) {//标识桩
          point = { name: res.pipe_name, point: res.point_lines.map(e => { return [Number(e.lon_wgs84), Number(e.lat_wgs84)] }) }
        } else if (res.pipe_type === 14) { //场站
          point = { name: res.pipe_name, point: [Number(res.lon), Number(res.lat)] }
        } else {
          point = res.point_lines.map(e => { return [Number(e.lon_wgs84), Number(e.lat_wgs84)] })
        }

        mainList.map(e => {
          if ((res.pid === 0 && res.id === e.mainId) || res.top_id === e.mainId) { e.points.push(point) };
          return { ...e }
        })
      })
    }
    setShowPipelines(mainList)
  }

  const traverseTree = (list) => {//遍历当前tree  返回对应数据
    if (list.children && list.children.length > 0) {
      list.children.forEach(res => { traverseTree(res) })
    } else {
      if (list.pipe_type === 3) {
        return list.point_lines
      } else {
        return list.point_lines.map(ele => { return [ele.lat_wgs84, ele.lon_wgs84] })
      }
    }
  }

  const uploadProcessFiles = async (file) => {//处理需要上传的文件
    let sel = selectModal
    sel.loading = true
    setSelectModal({ ...sel })
    document.getElementById('importFile').value = ''

    let types = file.name.split('.');
    if (types[types.length - 1] === 'xlsx' || types[types.length - 1] === 'xls') {
      // 通过FileReader对象读取文件
      const fileReader = new FileReader();
      fileReader.readAsBinaryString(file)//读取这个文件
      fileReader.onload = async event => {
        try {
          const { result } = event.target;
          // 以二进制流方式读取得到整份excel表格对象
          const workbook = XLSX.read(result, { type: 'binary' });
          // 存储获取到的数据
          let filedata = [];
          // 遍历每张工作表进行读取（这里默认只读取第一张表）
          for (const sheet in workbook.Sheets) {
            // esline-disable-next-line
            if (workbook.Sheets.hasOwnProperty(sheet)) {
              // 利用 sheet_to_json 方法将 excel 转成 json 数据
              filedata = filedata.concat(XLSX.utils.sheet_to_json(workbook.Sheets[sheet]));
              // break; // 如果只取第一张表，就取消注释这行
            }
          }
          let data = [];
          let point = []
          if (filedata.length > 0) {
            let keys = [];
            for (let key in filedata[0]) {
              keys.push(key);
            }
            if (keys.indexOf('序号') === -1 || keys.indexOf('经度') === -1 || keys.indexOf('纬度') === -1) {
              messageApi.open({
                type: 'warning',
                content: `文件 “表头名称” 不符合规范 或 数据不完整，请对照操作手册进行修改`,
              });
              return;
            }
          }
          for (let i = 0; i < filedata.length; i++) {
            let val = filedata[i];
            if (!val['序号'] || !val['经度'] || !val['纬度']) {
              messageApi.open({
                type: 'warning',
                content: `第${i + 2}行数据不完整，请修改后再上传`,
              });
              return;
            }
            let lon_lat = [Number(val['经度']), Number(val['纬度'])]
            let toWGS84ByGCJ = [Number(transformGCJ2WGS({ lat: lon_lat[1], lon: lon_lat[0] }).lon.toFixed(6)), Number(transformGCJ2WGS({ lat: lon_lat[1], lon: lon_lat[0] }).lat.toFixed(6))]
            data.push({
              pt_name: val['名称'] ? val['名称'] : Number(val['序号']),
              lon_wgs84: sel.upLoadCoordinateSystem === 'GCJ' ? toWGS84ByGCJ[0] : lon_lat[0],
              lat_wgs84: sel.upLoadCoordinateSystem === 'GCJ' ? toWGS84ByGCJ[1] : lon_lat[1],
            })
            point.push(sel.upLoadCoordinateSystem === 'GCJ' ? toWGS84ByGCJ : lon_lat)
          }
          let length = 0
          point.forEach((res, index) => {
            if (index > 0) {
              length += distance(point[index - 1], res)
            }
          })

          let obj = {
            access_token: token,
            pipe_name: types[0],
            pipe_len: (length / 1000).toFixed(2),
            pipe_type: sel.upLoadType,
            point_data: JSON.stringify(data),
          }
          message.success('文件解析成功!');
          let res = await submitOverviewDataApi(obj)
          if (res.ret !== 200) {
            messageApi.open({
              type: 'warning',
              content: `${res.msg || '数据跑丢了!'}`,
            });
            return;
          }

          messageApi.open({
            type: 'success',
            content: `${res.msg || '上传文件成功!'}`,
          });
          sel.loading = false
          sel.isOpen = false
          setSelectModal({ ...sel })
          getDataList()
        } catch (e) {
          // 这里可以抛出文件类型错误不正确的相关提示

          messageApi.open({
            type: 'warning',
            content: `文件解析失败!`,
          });
        }
      }
    } else if (types[types.length - 1] === 'kml' || types[types.length - 1] === 'ovkml') {
      let obj = {
        access_token: token,
        type: sel.upLoadCoordinateSystem === 'GCJ' ? 1 : 2,
        pipe_type: sel.upLoadType,
        file: file,
      }
      let res = await uploadKMLApi(obj)
      if (res.ret !== 200) {
        messageApi.open({
          type: 'warning',
          content: `${res.msg || '数据跑丢了!'}`,
        });
        return;
      }
      messageApi.open({
        type: 'success',
        content: `${res.msg || '上传文件成功!'}`,
      });
      sel.loading = false
      sel.isOpen = false
      setSelectModal({ ...sel })
      getDataList()
    }
    setSelectModal({ ...sel })
  }

  const findDifferences = (oldArray, newArray) => {//输出新改变值的下标
    const differentIndexes = [];
    // 检查数组长度是否一致
    const maxLength = Math.min(oldArray.length, newArray.length);

    // 定义一个比较对象的函数（这里简化为浅比较）
    function isObjectEqual (obj1, obj2) {
      const keys1 = Object.keys(obj1);
      const keys2 = Object.keys(obj2);

      // 如果键的数量不同，直接返回 false
      if (keys1.length !== keys2.length) {
        return false;
      }

      // 遍历所有键，检查值是否相同
      for (let key of keys1) {
        // 如果 obj2 中没有这个键，或者对应的值不同，返回 false
        if (obj1[key] !== obj2[key]) {
          return false;
        }
      }

      // 如果所有键和值都相同，返回 true
      return true;
    }

    // 遍历数组，比较对象
    for (let i = 0; i < maxLength; i++) {
      if (!isObjectEqual(oldArray[i], newArray[i])) {
        differentIndexes.push(i);
      }
    }

    // 如果新数组比旧数组长，检查新数组中多出来的部分
    for (let i = maxLength; i < newArray.length; i++) {
      // 这里可以认为新数组中多出来的对象与旧数组都不相同
      // 如果你想要更严格的比较（比如检查新数组中的对象是否在旧数组中有相似的），需要额外的逻辑
      differentIndexes.push(i);
    }
    oldDockInfoDataRef.current = newArray
    return differentIndexes;
  }

  //鼠标移动事件
  document.onmousemove = function () {
    setDivTop(window.event.pageY);
    setDivLeft(window.event.pageX);
  };

  useEffect(() => {
    let num = Math.floor(Math.random() * 3);
    setChooseMapKey(num);
    limitsAuthority.current = JSON.parse(localStorage.getItem('dock_AirportPermissionsArr'));
    getDataList()
    // eslint-disable-next-line
  }, [])

  return (
    <>
      {contextHolder}
      <Card
        styles={{ body: { padding: 0 } }}
        style={{ border: 0 }}
      >
        <div className='flex jcr radius8 hidden'>

          <>{/* 地图 */}
            <div
              className='wid100 pos_rel'
              style={{ height: '100vh' }}
            >
              <>{/* 地图容器 */}
                <RMap
                  features={[]}
                  ref={mapRef}
                  zoom={zoom}
                  center={center_point}
                  onMouseMove={(a, e) => { setCurMouseMove([e.lnglat.getLng(), e.lnglat.getLat()]) }}
                  onZoomChange={(map) => {
                    // zoom 最大20 最小1
                    setZoom(map.getZoom());
                    setCurSize(Math.floor(map.getZoom()))
                    setmapScale(map.getScale())
                  }}
                  onDragEnd={async (map) => { //地图拖动结束执行
                    if (circleMoveRef.current) { return; }
                    setCenterPoint(map.getCenter().toArray());
                    centerPointref.current = map.getCenter().toArray();
                  }}
                >
                  <>{/* 天地图图层 */}
                    <TileLayer getTileUrl={'http://t4.tianditu.gov.cn/DataServer?T=vec_w&tk=' + mapkeys[choose_map_key] + '&x=[x]&y=[y]&l=[z]'} />
                    <TileLayer getTileUrl={'http://t0.tianditu.gov.cn/DataServer?T=img_w&tk=' + mapkeys[choose_map_key] + '&x=[x]&y=[y]&l=[z]'} opacity={opacity} />
                    <TileLayer getTileUrl={'http://t4.tianditu.gov.cn/DataServer?T=cia_w&tk=' + mapkeys[choose_map_key] + '&x=[x]&y=[y]&l=[z]'} />
                  </>

                  <>{/* 所有机场 */}
                    {
                      dockList.length > 0 &&
                      dockList.map((res, index) => {
                        let dockStateTitle = ''
                        let dockIconUrl = undefined
                        switch (res?.dock_type) {
                          case 0:
                            dockStateTitle = res.dock_chargeState ? '充电中' : '待机'
                            dockIconUrl = res.dock_chargeState ? jc_cdz : jc_kxz
                            break;
                          case 1:
                            dockStateTitle = '现场调试'
                            dockIconUrl = jc_tsz
                            break;
                          case 2:
                            dockStateTitle = '远程调试'
                            dockIconUrl = jc_tsz
                            break;
                          case 3:
                            dockStateTitle = '固件升级中'
                            dockIconUrl = jc_tsz
                            break;
                          case 4:
                            dockStateTitle = '作业中'
                            dockIconUrl = jc_rwz
                            break;
                          case 5:
                            dockStateTitle = '机场未连接'
                            dockIconUrl = jc_lxz
                            break;

                          default:
                            break;
                        }
                        if ((dayjs().valueOf() - res.dock_time) > (30 * 1000)) { dockIconUrl = jc_lxz; dockStateTitle = '机场未连接' }
                        return (
                          <div key={index}>
                            <>{/* 机场 */}
                              {
                                visableArrRef.current.indexOf(0) > -1 &&
                                <AmapMarker
                                  style={{ cursor: 'default' }}
                                  visiable="true"
                                  draggable={false}
                                  position={[Number(res.lon), Number(res.lat)]}
                                  zIndex={1000}
                                  offset={[0, 0]}
                                >
                                  <Tooltip title={`${res.dockName} | ${dockStateTitle}  ${res.dock_electricQuantity}%`}>
                                    <img
                                      draggable='false'
                                      className='pos_abs w24 h24'
                                      style={{ top: '-12px', left: '-12px' }}
                                      alt='机场'
                                      src={dockIconUrl}
                                    />
                                  </Tooltip>

                                </AmapMarker>
                              }
                            </>

                            <>{/* 圆 */}
                              {
                                visableArrRef.current.indexOf(2) > -1 &&
                                <Circle
                                  center={[res.lon, res.lat]} //圆心
                                  radius={res.radius}//半径
                                  borderWeight={0} //描边的宽度
                                  strokeColor="#E50019" //轮廓线颜色
                                  strokeOpacity={1} //轮廓线透明度
                                  strokeWeight={3} //轮廓线宽度
                                  fillOpacity={0} //圆形填充透明度
                                  strokeStyle={"solid"} //轮廓线样式
                                  strokeDasharray={[10, 10]}
                                  fillColor="#1791fc" //圆形填充颜色
                                  zIndex={-1} //圆形的叠加顺序
                                  onMouseUp={async () => {
                                    let cen = mapRef.current.getCenter();
                                    if (cen.lng !== centerPointref.current[0] || cen.lat !== centerPointref.current[1]) {
                                      let altitude = await GetAltitudeFun([cen.lng, cen.lat]);
                                      setCenterAltitude(typeof altitude !== 'number' ? altitude : Number(altitude));
                                      centerPointref.current = [cen.lng, cen.lat]
                                    }
                                    setTimeout(() => { circleMoveRef.current = false; }, 500)
                                  }}
                                />
                              }
                            </>
                          </div>
                        )
                      })
                    }
                  </>

                  <>{/* 管线、标识桩、场站 */}
                    {
                      showPipelines && showPipelines.length > 0 &&
                      showPipelines.map((res, index) => {
                        return (
                          <div key={index}>
                            {
                              res.points.length > 0 &&
                              <div>
                                {
                                  res.pipe_type === 3//标识桩
                                    ? (
                                      <>
                                        <AmapLabelsLayer
                                          zooms={[0, 20]}
                                          zIndex={800}
                                          collision={zoom > 19 ? false : true}
                                        >
                                          {
                                            res.points.map((val, idx) => {
                                              return (
                                                <AmapLabelMarker
                                                  key={idx}
                                                  zIndex={100}
                                                  visiable={true}
                                                  position={val.point[0]}
                                                  icon={{
                                                    image: bsz_map,
                                                    size: [22, 22],
                                                    anchor: [11, 11]
                                                  }}
                                                  text={{
                                                    content: `${val.name}`,
                                                    direction: 'right',
                                                    offset: [0, -2],
                                                    style: {
                                                      fontSize: 14,
                                                      fillColor: 'white',
                                                      strokeColor: 'black',
                                                      strokeWidth: 5
                                                    }
                                                  }}
                                                >
                                                </AmapLabelMarker>
                                              )
                                            })
                                          }
                                        </AmapLabelsLayer>
                                      </>
                                    )
                                    : res.pipe_type === 14//场站
                                      ? (
                                        <AmapLabelsLayer zooms={[0, 20]} zIndex={1000} collision={zoom > 19 ? false : true}>
                                          {
                                            res.points.map((val, idx) => {
                                              return (
                                                <AmapLabelMarker
                                                  key={idx}
                                                  visiable={true}
                                                  position={val.point}
                                                  icon={{
                                                    image: cz_cs,
                                                    size: [32, 32],
                                                    anchor: [16, 16]
                                                  }}
                                                  text={{
                                                    offset: [0, -2],
                                                    content: val.name,
                                                    direction: 'right',
                                                    style: {
                                                      fontSize: 14,
                                                      strokeWidth: 5,
                                                      fillColor: 'white',
                                                      strokeColor: 'black',
                                                    }
                                                  }}
                                                />
                                              )
                                            })
                                          }
                                        </AmapLabelsLayer>
                                      )
                                      : (//航线
                                        <Polyline
                                          path={res.points}
                                          strokeWeight={4}
                                          strokeOpacity={1}
                                          fillOpacity={1}
                                          zIndex={-1}
                                          lineJoin='round'
                                          lineCap='round'
                                          bubble={true}
                                          isOutline={true}
                                          outlineColor='#FFFFFF'
                                          borderWeight={1}
                                          onMouseOut={() => {
                                            let info = { ...floating };
                                            info.visible = false;
                                            info.title = '';
                                            setFloating(info);
                                          }}
                                          onMouseOver={() => {
                                            let info = { ...floating };
                                            info.visible = true;
                                            info.title = res.name;
                                            setFloating(info);
                                          }}
                                          strokeColor={
                                            res.pipe_type === 1
                                              ? '#FFBD0A'
                                              : res.pipe_type === 7
                                                ? '#D32029'
                                                : res.pipe_type === 11
                                                  ? '#64D581'
                                                  : res.pipe_type === 12
                                                    ? '#000000'
                                                    : res.pipe_type === 13
                                                      ? '#00B5FF'
                                                      : '#FFFFFF'
                                          }
                                        />
                                      )
                                }
                              </div>




                            }
                          </div>
                        )
                      })

                    }
                  </>

                </RMap>
              </>

              <>{/* 左上 功能按钮 */}
                <div
                  className='pos_abs radius8 flex align_center h40'
                  style={{ top: 16, left: 16, backgroundColor: '#1F1F1F', border: 0 }}
                >
                  <>{/* 上传文件 */}

                  </>

                  <Divider className='hei100' type='vertical' style={{ margin: 0 }} />

                  <>{/* 显示隐藏 地图图标 */}
                    <Dropdown
                      trigger={['click']}
                      open={treeList.openVisableDropdown}
                      menu={{
                        items:
                          [
                            {
                              key: 1,
                              label: <>
                                {visableArrRef.current.indexOf(1) > -1
                                  ? <EyeOutlined className='marR8' />
                                  : <EyeInvisibleOutlined className='marR8 opa45' />}气管</>,
                            },
                            {
                              key: 7,
                              label: <>
                                {visableArrRef.current.indexOf(7) > -1
                                  ? <EyeOutlined className='marR8' />
                                  : <EyeInvisibleOutlined className='marR8 opa45' />}电网</>,
                            },
                            {
                              key: 11,
                              label: <>
                                {visableArrRef.current.indexOf(11) > -1
                                  ? <EyeOutlined className='marR8' />
                                  : <EyeInvisibleOutlined className='marR8 opa45' />}水管</>,
                            },
                            {
                              key: 12,
                              label: <>
                                {visableArrRef.current.indexOf(12) > -1
                                  ? <EyeOutlined className='marR8' />
                                  : <EyeInvisibleOutlined className='marR8 opa45' />}油管</>,
                            },
                            {
                              key: 13,
                              label: <>
                                {visableArrRef.current.indexOf(13) > -1
                                  ? <EyeOutlined className='marR8' />
                                  : <EyeInvisibleOutlined className='marR8 opa45' />}光缆</>,
                            },
                            {
                              key: 3,
                              label: <>
                                {visableArrRef.current.indexOf(3) > -1
                                  ? <EyeOutlined className='marR8' />
                                  : <EyeInvisibleOutlined className='marR8 opa45' />}标识桩</>,
                            },
                            {
                              key: 14,
                              label: <>
                                {visableArrRef.current.indexOf(14) > -1
                                  ? <EyeOutlined className='marR8' />
                                  : <EyeInvisibleOutlined className='marR8 opa45' />}场站</>,
                            },
                            {
                              key: 0,
                              label: <>
                                {visableArrRef.current.indexOf(0) > -1
                                  ? <EyeOutlined className='marR8' />
                                  : <EyeInvisibleOutlined className='marR8 opa45' />}机场</>,
                            },
                            {
                              key: 2,
                              label: <>
                                {visableArrRef.current.indexOf(2) > -1
                                  ? <EyeOutlined className='marR8' />
                                  : <EyeInvisibleOutlined className='marR8 opa45' />}机场范围</>,
                            },
                          ]
                        ,
                        onClick: (e) => {
                          if (visableArrRef.current.indexOf(Number(e.key)) > -1) {
                            visableArrRef.current.splice(visableArrRef.current.findIndex(v => v === Number(e.key)), 1)
                          } else {
                            visableArrRef.current.push(Number(e.key))
                          }
                          let dat = []
                          let tre = treeList
                          tre.data.forEach((res) => {
                            res.isShowLine = visableArrRef.current.indexOf(res.pipe_type) > -1
                            dat.push(res)
                          })
                          tre.data = dat
                          setTreeList({ ...tre })
                          editDataArr(tre.data)
                          setVisableArr([...visableArrRef.current])
                        },
                      }}
                      placement='bottomLeft'
                    >
                      <EyeOutlined
                        className='fs16 pd12'
                        onClick={() => {
                          let tre = treeList
                          tre.openVisableDropdown = !tre.openVisableDropdown
                          setTreeList({ ...tre })
                        }}
                      />
                    </Dropdown>
                  </>



                  <>{/* 切换图层 */}
                    {/* <BlockOutlined className='fs16 pd12' onClick={() => { setOpacity(!opacity) }} /> */}
                  </>
                </div>
              </>

              <>{/* 右下 像素尺寸 */}
                <div
                  className='pos_abs mar16'
                  style={{ bottom: 0, right: 0 }}
                >
                  <Card style={{ border: 0, margin: 0 }} styles={{ body: { padding: '4px 12px ' } }}>
                    <Space>
                      <span>{curMouseMove[0].toFixed(6)}</span>
                      <Divider type="vertical" />
                      <span>{curMouseMove[1].toFixed(6)}</span>
                      {/* <Divider type="vertical" />
                      <span>Elev.{altitudeList.V3}</span> */}
                      <Divider type="vertical" />
                      <span>Lv.{curSize}</span>
                    </Space>
                  </Card>
                </div>
              </>
            </div>
          </>

          {
            false &&
            <>{/* 右侧 信息栏 */}
              <div className='w284 pd16' style={{ background: '#262626', height: '100vh' }}>
                {
                  !loading
                    ? (
                      <Tree
                        // checkable
                        selectable={false}
                        className='radius8 hidden'
                        style={{ backgroundColor: '#262626', height: 'calc(100vh - 32px)', overflowY: 'auto' }}
                        showLine={true}
                        showIcon={true}
                        treeData={treeList.arrData}
                        onRightClick={(e) => {
                          let tre = treeList
                          tre.rightClickPageX = e.event.pageX
                          tre.rightClickPageY = e.event.pageY
                          tre.isRightClick = true
                          tre.rightClickId = e.node.id
                          tre.realId = e.node?.realId || undefined
                          tre.clickType = e.node.pipe_type
                          tre.list = e.node
                          setTreeList({ ...tre })
                        }}
                      />
                    )
                    : (<div className='hei100 wid100 flex jcc align_center'><Spin spinning={loading} /></div>)
                }

              </div>

            </>
          }

        </div>

        <>{/* 组件集 */}
          <>{/* 上传 对话框 */}
            <Modal
              title=""
              width={416}
              footer={false}
              closable={false}
              destroyOnClose={true}
              open={selectModal.isOpen}
            >
              <div className='marB8 flex_row align_center'>
                <span className='fs22 marR16 col_primary'><ExclamationCircleOutlined /></span>
                <span style={{ fontWeight: 500, fontSize: 16, color: 'rgba(255, 255, 255, 0.85)' }}>
                  {
                    `上传  ${Number(selectModal.upLoadType) === 1
                      ? '气管'
                      : Number(selectModal.upLoadType) === 3
                        ? '标识桩'
                        : Number(selectModal.upLoadType) === 7
                          ? '电网'
                          : Number(selectModal.upLoadType) === 11
                            ? '水管'
                            : Number(selectModal.upLoadType) === 12
                              ? '油管'
                              : Number(selectModal.upLoadType) === 13
                                ? '光缆'
                                : ''
                    }`
                  }
                </span>
              </div>

              <div className='fs14 marL38' style={{ fontSize: 14, color: 'rgba(255, 255, 255, 0.85)' }}>
                请选择要上传的坐标系
              </div>

              <div className='marT24 tr'>
                <Space>
                  <Button
                    onClick={() => {
                      let sel = selectModal
                      sel.isOpen = false
                      sel.upLoadType = 0
                      setSelectModal({ ...sel })
                    }}
                  >
                    取消
                  </Button>

                  <Button
                    loading={selectModal.loading}
                    type="primary"
                    onClick={() => {
                      let sel = selectModal
                      sel.upLoadCoordinateSystem = 'W84'
                      setSelectModal({ ...sel })
                      document.getElementById('importFile').click();
                    }}
                  >
                    WGS84
                  </Button>

                  <Button
                    loading={selectModal.loading}
                    type="primary"
                    onClick={() => {
                      let sel = selectModal
                      sel.upLoadCoordinateSystem = 'GCJ'
                      setSelectModal({ ...sel })
                      document.getElementById('importFile').click();
                    }}
                  >
                    GCJ
                  </Button>
                </Space>
              </div>

            </Modal>
          </>

          <>{/* 上传 input框 */}
            <input id="importFile" type="file" accept=".xls,.xlsx,.kml,.ovkml" hidden={true}
              onChange={(e) => {
                let file = e.target.files[0];
                // readExcel(file, 'stake', 'WGS84');
                uploadProcessFiles(file);
              }}
            />
          </>

          <>{/* 右击tree  展示菜单 */}
            {
              treeList.isRightClick &&
              <div
                className='pos_abs radius8'
                style={{
                  zIndex: 20,
                  color: 'white',
                  fontSize: '14px',
                  background: '#1F1F1F',
                  padding: '6px 8px',
                  top: treeList.rightClickPageY - 60,
                  left: treeList.rightClickPageX - 300,
                }}
                onMouseLeave={() => {
                  let tre = treeList
                  tre.isRightClick = false
                  setTreeList({ ...tre })
                }}
              >
                <Button
                  type='text'
                  className='wid100'
                  icon={<FontColorsOutlined />}
                  onClick={async () => {
                    if (treeList.list.type === 14) {
                      stationForm.resetFields()
                      let sta = stationDrawer
                      sta.isOpen = true
                      sta.upLoadType = 14
                      sta.title = '修改场站'
                      sta.st_id = treeList.list.realId
                      sta.loading = true
                      setStationDrawer({ ...sta })
                      let res = await getStationInfoApi({ access_token: token, st_id: treeList.list.realId })
                      sta.loading = false
                      setStationDrawer({ ...sta })
                      if (res.ret !== 200) { message.warning(res.msg || '数据跑丢了！'); return }
                      stationForm.setFieldsValue({
                        stationName: res.data.station_name,
                        longitude: res.data.lon,
                        latitude: res.data.lat
                      })
                    } else {
                      let tre = treeList
                      tre.isRightClick = false
                      tre.openNewName = true
                      tre.oldName = treeList.data.find(res => res.id === tre.rightClickId)?.pipe_name
                      setTreeList({ ...tre })
                    }
                  }}
                >
                  <div className='wid100 flex jcl'>{treeList.list.type === 14 ? '修改' : '重命名'}</div>
                </Button>

                <Divider style={{ margin: '4px 0' }} />

                <Button
                  type='text'
                  className='wid100'
                  icon={<DeleteOutlined />}
                  onClick={() => {
                    let tre = treeList
                    tre.isRightClick = false
                    tre.openDel = true
                    setTreeList({ ...tre })
                  }}
                >
                  <div className='wid100 flex jcl'>删除</div>
                </Button>
              </div>
            }
          </>

          <>{/* 场站、地图定位 对话框 */}
            <Drawer
              width={256}
              open={stationDrawer.isOpen}
              title={stationDrawer.title}
              extra={
                <Space>
                  <Button
                    type='primary'
                    disabled={stationDrawer.loading}
                    onClick={() => { document.getElementById('submit').click() }}
                  >
                    提交
                  </Button>
                </Space>
              }
              onClose={() => {
                let sta = stationDrawer
                sta.isOpen = false
                sta.upLoadType = 0
                setStationDrawer({ ...sta })
              }}
            >
              <Spin spinning={stationDrawer.loading}>
                <Form
                  form={stationForm}
                  layout='vertical'
                  onFinish={submitDrawer}
                >
                  {
                    stationDrawer.upLoadType === 14 &&
                    <Form.Item
                      label="场站名称"
                      name="stationName"
                      rules={[{ required: true }]}
                    >
                      <Input />
                    </Form.Item>
                  }

                  <Form.Item
                    label="经度"
                    name="longitude"
                    tooltip="仅支持wsg84坐标系"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    label="纬度"
                    name="latitude"
                    tooltip="仅支持wsg84坐标系"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>


                  <Form.Item>
                    <Button
                      id='submit'
                      type="primary"
                      className='none'
                      htmlType="submit"
                    >
                      提交
                    </Button>
                  </Form.Item>
                </Form>
              </Spin>
            </Drawer>
          </>

          <>{/* 删除 对话框 */}
            <Modal
              width={360}
              open={treeList.openDel}
              title={`是否删除${treeList.data.find(res => res.id === treeList.rightClickId)?.pipe_name}`}
              onOk={async () => {
                let tre = treeList
                let res
                if (tre.clickType === 14) {
                  res = await delStationListApi({ access_token: token, st_id: tre.realId })
                } else {
                  res = await delOverviewListApi({ access_token: token, pr_id: tre.rightClickId, })
                }

                if (res.ret !== 200) {
                  messageApi.open({ type: 'warning', content: `${res.msg || '数据跑丢了!'}` });
                  return
                }
                edtiPoints(tre.data.map(res => { return { ...res, isShowLine: false } }))
                tre.openDel = false
                setTreeList({ ...tre })
                getDataList()
              }}
              onCancel={() => {
                let tre = treeList
                tre.openDel = false
                setTreeList({ ...tre })
              }}
            />
          </>

          <>{/* 重命名 对话框 */}
            <Modal
              width={360}
              open={treeList.openNewName}
              title='重命名'
              onOk={async () => {
                let tre = treeList
                let res = await setOverviewListApi({ access_token: token, pr_id: tre.rightClickId, pipe_name: tre.newName, pipe_type: tre.clickType })
                if (res.ret !== 200) { messageApi.open({ type: 'warning', content: `${res.msg || '数据跑丢了!'}` }); return }
                tre.openNewName = false
                setTreeList({ ...tre })
                getDataList()
              }}
              onCancel={() => {
                let tre = treeList
                tre.openNewName = false
                setTreeList({ ...tre })
              }}
            >

              <Input
                defaultValue={treeList.oldName}
                onChange={(e) => {
                  let tre = treeList
                  tre.newName = e.target.value
                  setTreeList({ ...tre })
                }}
              />
            </Modal>
          </>

          <>{/* 鼠标移动展示管道名称 */}
            <div id='div_info' className='pos_abs' style={{ zIndex: 20, left: divLeft + 10, padding: '6px 8px', color: 'white', top: divTop + 15, background: '#000000bf', display: floating.visible ? '' : 'none', }}>
              {floating.title}
            </div>
          </>
        </>
      </Card>
    </>
  )
}
export default PipelineOverview;